<div class="overlay" (click)="closeOverlay()" *ngIf="navActive"></div>

<aside class="sidebar-nav" [ngClass]="{ active: navActive }" (click)="onSidebarClick($event)">
  <nav class="nav-items">
    <ng-container *ngFor="let navItem of navBloc.sideNavSubject$ | async">
      <ng-container *ngIf="navItem.type !== navType.invites; else invites">
        <a *ngIf="!navItem.external" [routerLink]="navItem.link" class="nav-item" routerLinkActive="nav-active">
          <span class="nav-item-inner">
            <svg-icon [src]="navItem.icon" ngClass="navIcon"></svg-icon>
            <span class="nav-item-text">{{ navItem.title }}</span>
          </span>
        </a>
        <a
          *ngIf="navItem.external"
          [href]="navItem.link"
          class="nav-item"
          (click)="closeOverlay()"
          target="_blank"
          routerLinkActive="nav-active">
          <span class="nav-item-inner">
            <svg-icon [src]="navItem.icon" class="navIcon"></svg-icon>
            <span class="nav-item-text">{{ navItem.title }}</span>
            <svg-icon src="/assets/icons/expand.svg" class="external-link-icon"></svg-icon>
          </span>
        </a>
      </ng-container>
      <ng-template #invites>
        <ng-container *ngIf="(sharingBloc.invites$ | async)?.length > 0">
          <a [routerLink]="navItem.link" class="nav-item" routerLinkActive="nav-active">
            <span class="nav-item-inner">
              <svg-icon [src]="navItem.icon" ngClass="navIcon"></svg-icon>
              <span class="nav-item-text">{{ navItem.title }}</span>
            </span>
          </a>
        </ng-container>
      </ng-template>
    </ng-container>

    <ng-container *ngIf="navBloc.moreApps$ | async as apps">
      <ng-container *ngIf="apps.length > 1">
        <div class="more-apps">
          <span class="more-apps-title">More by Kumanu</span>
        </div>

        <ng-container *ngFor="let app of apps">
          <a *ngIf="!app?.currentApp" [href]="app?.link" class="nav-item" (click)="trackEvent(app)" target="_blank">
            <span class="nav-item-inner">
              <svg-icon [src]="app?.whiteIcon" class="navIcon"></svg-icon>
              <span class="nav-item-text">{{ app?.title }}</span>
              <svg-icon src="/assets/icons/expand.svg" class="external-link-icon"></svg-icon>
            </span>
          </a>
        </ng-container>
      </ng-container>
    </ng-container>
  </nav>

  <nav class="tertiary-nav">
    <div class="policies-container">
      <a class="policy-item" routerLink="/privacy" routerLinkActive="nav-active">Privacy</a>
      <span class="policy-dot">&middot;</span>
      <a class="policy-item" routerLink="/eula" routerLinkActive="nav-active">Acceptable Use</a>
    </div>
    <div class="tertiary-line">
      <div class="tertiary-nav-inner">
        <span class="tertiary-nav-item-text">{{ (dataStore?.user$ | async)?.nickname }}</span>
        <a routerLink="/logout" class="tertiary-nav-item" routerLinkActive="nav-active">Sign Out</a>
      </div>
    </div>
  </nav>
</aside>
